export default __webpack_public_path__ + "static/media/icon-user-empty.a4776090.svg";